import { basic, initSidebar, initTopbar } from './modules/layouts';
import { initLocaleDatetime } from './modules/components';

initSidebar();
initTopbar();
initLocaleDatetime();
basic();
